
import { TimelineMax, Bounce, Power1, Power3, TweenLite, Back} from "gsap";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { BitmapTextStyleOptions } from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";
import { SanBitmapCountUp } from "../../../component/SanBitmapCountUp";
import { SanEngineManager } from "../../../engine/SanEngineManager";
import { IDimConfig, LayoutDimData, ResizeHelper } from "@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import { AnimationEffects } from "../../../effects/AnimationEffects";
import { Text } from "pixi.js";
import { TranslationConfig } from "../../../translation/TranslationConfig";
import { Translation } from "@nolimitcity/slot-game/bin/core/translation/Translation";
import { TextStyleConfig } from "../../../translation/TextStyleConfig";
import { SoundManager } from "../../../resource/sound/SoundManager";
import { SoundConfig } from "../../../SoundConfig";

export class SanCounter extends PIXI.Container {

    protected readonly counterDim:IDimConfig = {
        dimOrientation : {
            landscape :{
                scale:      new PIXI.Point( 1, 1),
                position:   new PIXI.Point( 360, 340),
                layout :{
                    left:   new PIXI.Point( 360, 340),
                    right:  new PIXI.Point( 360, 340)
                }
            },
            portrait :{
                scale:      new PIXI.Point( 1, 1),
                position:   new PIXI.Point( 360, 200)
            }
        },
        WIDTH: 740,
        HEIGHT: 740,
    };

    public get dim():LayoutDimData{ return ResizeHelper.calcDim(this.counterDim); };

    private readonly _style:BitmapTextStyleOptions = {
        font : {
            name : "NumbersWinCountUp",
            size : 48
        },
        tint : parseInt(("#ffffff").replace(/^#/, ''), 16),
    };

    protected _countUp:SanBitmapCountUp;
    protected _abortTimeline:TimelineMax | null;

    protected _timeline:TimelineMax | null;
    protected _timelineWays:TimelineMax | null;
    protected bounceTl:TimelineMax;

    private moveDownDistanceY:number = 120;
    protected _textPost:Text;

    public isBigWinPos:boolean = false;

    constructor() {
        super();
        this.init();
    }

    public maniacUpAnimation(from:number, to:number, duration:number, winIndx:number = 0):TimelineMax {
        const deciNumber:number = MathHelper.floorToDecimals(to,2);
        const shrinkScale:number = 1 - Math.min(winIndx,4)*0.07;

        this.isBigWinPos = true;

        this.onResize();
        this.showCounter(0,undefined,true);
        this._timeline = Helper.timeLineKiller(this._timeline!, new TimelineMax({onComplete:() => this.stopCounter(to)}));
        this._timeline.add(() => {
            this._countUp.alpha = 1;
            // this._countUp.scale.set(1,1);
            SoundManager.stopSoundEffect(SoundConfig.instance.WIN_COUNT);
            SoundManager.stopSoundEffect(SoundConfig.instance.BIG_WIN_COUNT);
        });
        this._timeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.BIG_WIN_COUNT,Number.MAX_SAFE_INTEGER));
        this._timeline.add(this._countUp.getCountUpAnimation(from, deciNumber, {duration : duration, ease : Power1.easeOut}));

        if((to.toString().length + 3) < 11){
            this._timeline.to(this._countUp.scale, duration,{x:shrinkScale,y:shrinkScale},0);
            this._timeline.to(this._countUp, (duration*0.1 < 0.1 ? 0.1 : duration*0.1), {alpha:1},0);
            if(winIndx > 0) this._timeline.add(
                AnimationEffects.Shake({
                    obj:this._countUp,
                    x:1,
                    y:1,
                    hertz:70,
                    Intensity:3.5,
                    duration:duration*0.4,
                    positionCb:() => new PIXI.Point(0,0)
                }),duration*0.6);
        }else{
            this._countUp.scale.set(1,1)
        }

        return this._timeline;
    }

    public getCountUpAnimation(from:number, to:number, duration:number, winIndx:number = 0, isBigWinPos:boolean = false,bigWinInit:boolean = false):TimelineMax {
        const deciNumber:number = MathHelper.floorToDecimals(to,2);
        const shrinkScale:number = 1 - Math.min(winIndx,4)*0.07;

        this.isBigWinPos = isBigWinPos;

        this.onResize();

        this._timeline = Helper.timeLineKiller(this._timeline!, new TimelineMax({onComplete:() => this.setValue(to)}));
        this._timeline.add(() => this._countUp.alpha = 1);
        this._timeline.add(() => {
            SoundManager.stopSoundEffect(SoundConfig.instance.WIN_COUNT);
            SoundManager.stopSoundEffect(SoundConfig.instance.BIG_WIN_COUNT);
        });
        if(bigWinInit) this._timeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.BIG_WIN_INIT_COUNTUP));
        else if(winIndx != 0) this._timeline.add(() => SoundManager.playSoundEffect(this.isBigWinPos ? SoundConfig.instance.BIG_WIN_COUNT : SoundConfig.instance.WIN_COUNT ,Number.MAX_SAFE_INTEGER));
        this._timeline.add(this._countUp.getCountUpAnimation(from, deciNumber, {duration : duration, ease : Power1.easeOut}));
        if((to.toString().length + 3) < 11){
            this._timeline.to(this._countUp.scale, duration,{x:shrinkScale,y:shrinkScale},0);
            this._timeline.to(this._countUp, (duration*0.1 < 0.1 ? 0.1 : duration*0.1), {alpha:1},0);
            if(winIndx > 0) this._timeline.add(
                AnimationEffects.Shake({
                    obj:this._countUp,
                    x:1,
                    y:1,
                    hertz:70,
                    Intensity:3.5,
                    duration:duration*0.4,
                    positionCb:() => new PIXI.Point(0,0)
                }),duration*0.6);
        }else{
            this._countUp.scale.set(1,1)
        }
        return this._timeline;
    }

    public idleStop(endValue:number,ways:number):void {
        this._timeline = Helper.timeLineKiller(this._timeline as TimelineMax, new TimelineMax());
        if(endValue != undefined) this.showCounter(endValue,ways);

        let endDelay:number = 0.8;

        this._timeline.delay(endDelay);
        this._timeline.fromTo(this._countUp, 0.6,{alpha : 1}, {alpha : 0},0);
        this._timeline.fromTo(this._textPost, 0.6,{alpha : 1}, {alpha : 0},0);
    }

    protected init():void {
        this._countUp = this.addChild(new SanBitmapCountUp({style : this._style}));
        
        this._countUp.shrinkSize = true;
        this._countUp.maxTextWidth = SanEngineManager.ReelAreaWidth/1.35;
        this._countUp.alpha = 0;
        this.addChild(this._countUp);

        this._textPost = this.createTextObject();
        this._textPost.position.y = this.moveDownDistanceY;
        this._textPost.updateTransform();
    }

    protected createTextObject():Text{
        const textObj = new Text("Ways");
        textObj.style = TextStyleConfig.XWAYS_WIN;
        textObj.anchor.set(0.5,0.5);
        textObj.alpha = 0;
        textObj.position.x = 0;
        
        this.addChild(textObj);
        return textObj;
    }

    public stopCounter(to?:number):void {
        // this._timeline?.eventCallback("onComplete")();
        this._timeline = Helper.timeLineNuller(this._timeline);
        SoundManager.stopSoundEffect(SoundConfig.instance.WIN_COUNT);
        SoundManager.stopSoundEffect(SoundConfig.instance.BIG_WIN_COUNT);
        if(to != undefined) this._countUp.showValue(to);
    }

    private set waysText(value:number){
        this._textPost.text = value.toString() + " " + Translation.translate((value == 1 ? TranslationConfig.WAY_WON : TranslationConfig.WAYS_WON));
        this._textPost.updateTransform();
    }

    public showCounter(to?:number, ways?:number,force?:boolean):void {
        if(force){
            this._abortTimeline = Helper.timeLineNuller(this._abortTimeline!,true);
            this._timelineWays = Helper.timeLineNuller(this._timelineWays!,true);
            this._timeline = Helper.timeLineNuller(this._timeline!,true);
        }

        this._countUp.alpha = 1;
        this._textPost.alpha = 1;

        if(this._countUp.width < 500 && this._countUp.text.length + 3 < 12)
            this._countUp.scale.set(1, 1);
        
        this._textPost.y = this.moveDownDistanceY;
        if(ways != undefined) this.waysText = ways;
        else this._textPost.alpha = 0;
        if(to != undefined) this._countUp.showValue(to);
        else this._countUp.alpha = 0;
    }

    public setValue(val:number):void {
        this._countUp.showValue(val);
    }

    public get toBigToAnim():boolean{
        return this._countUp.text.length + 3 > 11;
    }

    public bounceHit(intencity:number = 0,duration:number = 0.3, forceBounce:boolean = false):TimelineMax{
        this.bounceTl = Helper.timeLineKiller(this.bounceTl, new TimelineMax());
        if(!forceBounce || (!intencity || this.toBigToAnim)) return this.bounceTl;
        
        intencity = Math.min(intencity,6);
        const inc:number = intencity*0.05;
        this.bounceTl.to(this._countUp.scale,duration/2,{x:1.15+inc,y:1.15+inc},0);
        this.bounceTl.to(this._countUp.scale,duration,{x:1,y:1,ease:Bounce.easeOut},duration/2);
        this.bounceTl.play();

        return this.bounceTl;
    }

    public showWaysWon(ways:number, duration:number,delay:number = 0):TimelineMax {
        this.waysText = ways;

        this._timelineWays = Helper.timeLineKiller(this._timelineWays!,new TimelineMax());
        this._timelineWays.add([
            TweenLite.to(this._textPost, duration, {alpha:1, ease:Power3.easeOut}),
            TweenLite.fromTo(this._textPost.position, duration,{y:this._countUp.height/2}, {y:this.moveDownDistanceY, ease:Power3.easeOut}),
        ],0)
        if(delay){
            this._timelineWays.add([
                TweenLite.to(this._textPost, 1.5, {alpha:0}),
            ],"+="+delay)
        }
        return this._timelineWays;
    }

    public waysWonHide():TimelineMax{
        this._timelineWays = Helper.timeLineKiller(this._timelineWays as TimelineMax, new TimelineMax());
        this._timelineWays.delay(0.6);
        this._timelineWays.fromTo(this._textPost,0.2,{alpha:1},{alpha:0,ease:Power3.easeInOut},0);
        return this._timelineWays;
    }

    private isTotalWin:boolean = false;
    public playTotalWin(amm:number,active:boolean):void{
        this.isTotalWin = active

        if(active){
            this.showCounter(amm,undefined,true);
            this.onResize();
        }else
            this.abort(undefined,undefined,0.35,0);
    }

    public normalStop(endValue?:number,ways?:number, duration:number = 0.5,delay?:number):void {

        this._abortTimeline = new TimelineMax({ onComplete:() => this._abortTimeline = null});
        this._timelineWays = Helper.timeLineNuller(this._timelineWays!,true);
        this._timeline = Helper.timeLineNuller(this._timeline!,true);

        this._countUp.alpha = 1;
        this._textPost.alpha = 1;
        
        this._textPost.y = this.moveDownDistanceY;

        if(ways != undefined) this.waysText = ways;
        else this._textPost.alpha = 0;
        if(endValue != undefined) this._countUp.showValue(endValue);
        else this._countUp.alpha = 0;
        
        this._abortTimeline = new TimelineMax({ onComplete:() => this._abortTimeline = null});

        let endDelay:number = 0.65;

        if(delay != undefined) endDelay = delay;

        this._abortTimeline.to(this._countUp, duration,{alpha : 0},endDelay);
        if(this._textPost.alpha != 0)
            this._abortTimeline.to(this._textPost, duration,{alpha : 0},endDelay);
    }

    public abort(endValue?:number,ways?:number, duration:number = 0.5,delay?:number):void {
        
        // this.bounceTl = Helper.timeLineKiller(this.bounceTl!, new TimelineMax(),true);
        this._timeline = Helper.timeLineKiller(this._timeline!, new TimelineMax(),true);
        this._timelineWays = Helper.timeLineKiller(this._timelineWays!, new TimelineMax(),true);

        if(this._abortTimeline && this._abortTimeline.isActive()) return;
        this._abortTimeline = new TimelineMax({ onComplete:() => this._abortTimeline = null});
        if(this._countUp.alpha == 0) return;
        if(endValue != undefined) this.showCounter(endValue,ways);

        let startAlpha:number = 1;
        let endDelay:number = this.isBigWinPos ? 2 : 0.85;

        if(delay != undefined) endDelay = delay;

        if(this._countUp.alpha != startAlpha){
            startAlpha = this._countUp.alpha;
            endDelay = 0;
        }

        this._abortTimeline.fromTo(this._countUp, duration,{alpha : startAlpha}, {alpha : 0},endDelay);

        if(this.isBigWinPos){
            this._abortTimeline.to(this.position,0.75,{x:this.dim.position.x,y:this.dim.position.y},0.3);
            this.isBigWinPos = false;
        }

        if(this._textPost.alpha != 0)
            this._abortTimeline.fromTo(this._textPost, duration,{alpha : startAlpha}, {alpha : 0},endDelay);
    }

    public onResize():void{

        if(this.isBigWinPos){
            this.position.y = this.dim.position.y + 250;
            this.scale = this.dim.scale;
        }else if(this.isTotalWin){
            this.position.y = this.dim.position.y - (ResizeHelper.IsLandscape() ? 125 : 15);
            this.scale = ResizeHelper.IsLandscape() ? new PIXI.Point(0.8,0.8) : this.dim.scale;
        }else{
            this.position = this.dim.position;
            this.scale = this.dim.scale;
        }
    }
}
